import { render, staticRenderFns } from "./NewApiConfig.vue?vue&type=template&id=e0ea8bb8&scoped=true"
import script from "./NewApiConfig.vue?vue&type=script&lang=ts"
export * from "./NewApiConfig.vue?vue&type=script&lang=ts"
import style0 from "./NewApiConfig.vue?vue&type=style&index=0&id=e0ea8bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ea8bb8",
  null
  
)

export default component.exports